import EdLabel from './ed-label/ed-label.vue';
import EdInput from './ed-input/ed-input.vue';
import EdCheckBoxForm from './ed-checkbox-form/ed-checkbox-form.vue';
import EdInputForm from './ed-input-form/ed-input-form.vue';
import EdDisclamer from './ed-disclamer/ed-disclamer.vue';
import EdTextarea from './ed-textarea/ed-textarea.vue';
import EdTextareaForm from './ed-textarea-form/ed-textarea-form.vue';
import EdButton from './ed-button/ed-button.vue';
import EdForm from './ed-form/ed-form.vue';
import EdDropzone from './ed-dropzone/ed-dropzone.vue';
import EdProgressBar from '../../content/components/ed-progress/ed-progress.vue';
import EdSelect from './ed-select/ed-select.vue';
import EdSelectCustom from './ed-select-custom/ed-select-custom.vue';
import EdSelectCustomMultiple from './ed-select-custom-multiple/ed-select-custom-multiple.vue';
import EdEditableLabel from './ed-editable-label/ed-editable-label.vue';
import EdRadio from './ed-radio/ed-radio.vue';
import EdDatePicker from './ed-date-picker/ed-date-picker.component.vue';
import EdRadioButton from './ed-radio-button/ed-radio-button.vue';
import EdAutocomplete from './ed-autocomplete/ed-autocomplete.vue';
import EdTextField from './ed-text-field/ed-text-field.component.vue';
import EdDateTimePicker from './ed-datetime-picker/ed-datetime-picker.component.vue';

export default {
  EdLabel,
  EdInput,
  EdCheckBoxForm,
  EdInputForm,
  EdDisclamer,
  EdTextarea,
  EdTextareaForm,
  EdButton,
  EdForm,
  EdDropzone,
  EdSelect,
  EdProgressBar,
  EdEditableLabel,
  EdRadio,
  EdRadioButton,
  EdDatePicker,
  EdAutocomplete,
  EdTextField,
  EdDateTimePicker,
  EdSelectCustom,
  EdSelectCustomMultiple,
}